module.exports = __webpack_public_path__ + "img/other9.e970c0d3.svg";